
// import React, { useState, useEffect } from "react"
// import {
//   ThemeProvider,
//   createTheme,
//   Box,
//   Typography,
//   Container,
//   CssBaseline,
//   Button,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
// } from "@mui/material"
// import { DataGrid } from "@mui/x-data-grid"
// import * as XLSX from "xlsx"
// import axios from "axios"
// import Swal from "sweetalert2"

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: "#000000",
//     },
//     secondary: {
//       main: "#dc004e",
//     },
//   },
//   typography: {
//     fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
//   },
// })

// function RegisterInvestor() {
//   const [data, setData] = useState([])
//   const [filteredData, setFilteredData] = useState([])
//   const [searchField, setSearchField] = useState("")
//   const [searchValue, setSearchValue] = useState("")
//   const [loading, setLoading] = useState(true)
//   const [selectedRows, setSelectedRows] = useState([])
//   const [dialog, setDialog] = useState({ open: false, type: "", rowIds: [] })
//   const [pageSize, setPageSize] = useState(10)
//   const [snackbarOpen, setSnackbarOpen] = useState(false)
//   const [snackbarMessage, setSnackbarMessage] = useState("")
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success")

//   useEffect(() => {
//     fetchData()
//   }, [])

//   const fetchData = async () => {
//     try {
//       const response = await axios.get("https://puneexpobackend.tdtlworld.com/api/investor_data/", {
//         headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
//       })

//       const filteredInvestors = response.data.filter((investor) => !investor.admin_approval)

//       const formattedData = filteredInvestors.map((investor, index) => ({
//         ...investor,
//         id: investor.id,
//         serial_number: index + 1,
//       }))

//       setData(formattedData)
//       setFilteredData(formattedData)
//     } catch (error) {
//       console.error("Error fetching data:", error)
//       setSnackbarMessage("Error fetching data. Please try again.")
//       setSnackbarSeverity("error")
//       setSnackbarOpen(true)
//     } finally {
//       setLoading(false)
//     }
//   }

//   const handleDialogOpen = (type, rowIds) => setDialog({ open: true, type, rowIds })
//   const handleDialogClose = () => setDialog({ open: false, type: "", rowIds: [] })

//   const handleAction = async (action) => {
//     try {
//       const { rowIds } = dialog
//       const payload = { ivestors: rowIds }

//       await axios.post(`https://puneexpobackend.tdtlworld.com/api/approve_investor/`, payload, {
//         headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
//       })

//       Swal.fire({
//         title: `Investors ${action}ed successfully.`,
//         icon: "success",
//         confirmButtonText: "OK",
//       })

//       const updatedData = data.filter((row) => !rowIds.includes(row.id))
//       setData(updatedData)
//       setFilteredData(updatedData)
//     } catch (error) {
//       console.error(`Error ${action}ing investors:`, error)

//       Swal.fire({
//         title: `Failed to ${action} investors.`,
//         icon: "error",
//         confirmButtonText: "OK",
//       })
//     } finally {
//       handleDialogClose()
//     }
//   }

//   const handleSearch = () => {
//     if (!searchField || !searchValue) {
//       setFilteredData(data)
//       return
//     }

//     const filtered = data.filter((item) => {
//       const fieldValue = item[searchField]?.toString().toLowerCase() || ""
//       return fieldValue.includes(searchValue.toLowerCase())
//     })

//     setFilteredData(filtered)
//   }

//   const handleDownloadExcel = () => {
//     const worksheet = XLSX.utils.json_to_sheet(filteredData)
//     const workbook = XLSX.utils.book_new()
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Investors")
//     XLSX.writeFile(workbook, "Investors_Approval.xlsx")
//   }

//   const handleIndividualAction = async (row, action) => {
//     try {
//       const payload = { investors: [row.id] }
//       await axios.post(`https://puneexpobackend.tdtlworld.com/api/${action}_investor/`, payload, {
//         headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
//       })

//       Swal.fire({
//         title: `Investor ${action === "accept" ? "approved" : "denied"} successfully.`,
//         icon: "success",
//         confirmButtonText: "OK",
//       })

//       const updatedData = data.filter((item) => item.id !== row.id)
//       setData(updatedData)
//       setFilteredData(updatedData)
//     } catch (error) {
//       console.error(`Error ${action === "accept" ? "approving" : "denying"} investor:`, error)
//       Swal.fire({
//         title: `Failed to ${action} investor.`,
//         icon: "error",
//         confirmButtonText: "OK",
//       })
//     }
//   }

//   const columns = [
    
//     { field: "full_name", headerName: "Name", flex: 1, minWidth: 150 },
//     { field: "email", headerName: "Email", flex: 1, minWidth: 200 },
//     { field: "role", headerName: "Role", flex: 1, minWidth: 150 },
//     { field: "organisation", headerName: "Organisation", flex: 1, minWidth: 180 },
//     // {
//     //   field: "actions",
//     //   headerName: "Actions",
//     //   width: 200,
//     //   renderCell: (params) => (
//     //     <Box sx={{ display: "flex", gap: 1 }}>
//     //       <Button
//     //         variant="outlined"
//     //         color="primary"
//     //         size="small"
//     //         onClick={() => handleIndividualAction(params.row, "accept")}
//     //       >
//     //         Accept
//     //       </Button>
//     //       <Button
//     //         variant="outlined"
//     //         color="secondary"
//     //         size="small"
//     //         onClick={() => handleIndividualAction(params.row, "deny")}
//     //       >
//     //         Deny
//     //       </Button>
//     //     </Box>
//     //   ),
//     // },
//   ]

//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <Container maxWidth="lg" sx={{ mt: 9, mb: 4 }}>
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             mb: 2,
//           }}
//         >
//           <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
//             <FormControl size="small" sx={{ minWidth: 200 }}>
//               <InputLabel>Search Field</InputLabel>
//               <Select value={searchField} onChange={(e) => setSearchField(e.target.value)} label="Search Field">
//                 <MenuItem value="">Select Field</MenuItem>
//                 <MenuItem value="full_name">Name</MenuItem>
//                 <MenuItem value="email">Email</MenuItem>
//                 <MenuItem value="role">Role</MenuItem>
//                 <MenuItem value="organisation">Organisation</MenuItem>
//               </Select>
//             </FormControl>

//             <TextField
//               size="small"
//               label="Search Value"
//               value={searchValue}
//               onChange={(e) => setSearchValue(e.target.value)}
//             />

//             <Button variant="contained" color="primary" onClick={handleSearch}>
//               Search
//             </Button>
//           </Box>

//           <Button variant="contained" color="primary" onClick={handleDownloadExcel}>
//             Download Excel
//           </Button>
//         </Box>
//         <Box sx={{ height: 600, width: "100%" }}>
//           {loading ? (
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 height: "100%",
//               }}
//             >
//               <CircularProgress />
//             </Box>
//           ) : (
//             <DataGrid
//               rows={filteredData}
//               columns={columns}
//               pageSize={pageSize}
//               onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
//               rowsPerPageOptions={[5, 10, 20]}
//               pagination
//               checkboxSelection
//               disableSelectionOnClick
//               onSelectionModelChange={(ids) => setSelectedRows(ids)}
//             />
//           )}
//         </Box>
//       </Container>

//       <Dialog open={dialog.open} onClose={handleDialogClose}>
//         <DialogTitle>{dialog.type === "accept" ? "Accept Investors" : "Deny Investors"}</DialogTitle>
//         <DialogContent>Are you sure you want to {dialog.type} the selected investors?</DialogContent>
//         <DialogActions>
//           <Button onClick={handleDialogClose}>Cancel</Button>
//           <Button onClick={() => handleAction(dialog.type)} color="primary">
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       >
//         <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: "100%" }}>
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </ThemeProvider>
//   )
// }

// export default RegisterInvestor;



import React, { useState, useEffect } from "react";
import {
  ThemeProvider,
  createTheme,
  Box,
  Typography,
  Container,
  CssBaseline,
  Button,
  Snackbar,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import axios from "axios";

const theme = createTheme({
  palette: {
    primary: {
      main: "#000000",
    },
    secondary: {
      main: "#dc004e",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function RegisterInvestor() {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [filters, setFilters] = useState({
    full_name: "",
    email: "",
    role: "",
    organisation: "",
    phone_number:"",
  });
  const [filterOptions, setFilterOptions] = useState({
    names: [],
    emails: [],
    roles: [],
    phoneNumbers:[],
    organisations: [],
  });
  const [pageSize, setPageSize] = useState(10);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        "https://puneexpobackend.tdtlworld.com/api/investor_data/",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      const investors = response.data.filter((item) => !item.admin_approval);

      const formatted = investors.map((item, index) => ({
        id: item.id,
        serial_number: index + 1,
        ...item,
      }));

      setRows(formatted);
      setFilteredRows(formatted);

      const names = [...new Set(formatted.map((i) => i.full_name))];
      const emails = [...new Set(formatted.map((i) => i.email))];
      const roles = [...new Set(formatted.map((i) => i.role))];
      const phoneNumbers = [...new Set(formatted.map((i) => i.phone_number))];
      const organisations = [...new Set(formatted.map((i) => i.organisation))];

      setFilterOptions({ names, emails, roles, organisations,phoneNumbers });
    } catch (error) {
      console.error("Error fetching data:", error);
      setSnackbarMessage("Error fetching data. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    let filtered = rows;
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        filtered = filtered.filter((row) =>
          row[key]?.toString().toLowerCase().includes(value.toLowerCase())
        );
      }
    });
    setFilteredRows(filtered);
  }, [filters, rows]);

  const handleDownloadExcel = () => {
    const exportData = filteredRows.map((row) => [
      row.serial_number,
      row.full_name,
      row.email,
      row.phoneNumbers,
      row.organisation,
      
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      ["S.No.", "Full Name", "Email", "Phone Numbers", "Organisation"],
      ...exportData,
    ]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Investors");
    XLSX.writeFile(workbook, "Investor_Approval_List.xlsx");
  };

  const columns = [
    { field: "serial_number", headerName: "S.No.", width: 100 },
    { field: "full_name", headerName: "Name", flex: 1, minWidth: 150 },
    { field: "email", headerName: "Email", flex: 1, minWidth: 200 },
    { field: "phone_number", headerName: "Phone Numbers", flex: 1, minWidth: 150 },
    { field: "organisation", headerName: "Organisation", flex: 1, minWidth: 180 },
  ];

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="lg" sx={{ mt: 10, mb: 4 }}>
        <Typography variant="h4" sx={{ mb: 4, fontWeight: "bold", color: "#37474f" }}>
          Investors List
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Name</InputLabel>
              <Select
                name="full_name"
                value={filters.full_name}
                onChange={handleFilterChange}
                label="Name"
              >
                <MenuItem value="">All</MenuItem>
                {filterOptions.names.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Email</InputLabel>
              <Select
                name="email"
                value={filters.email}
                onChange={handleFilterChange}
                label="Email"
              >
                <MenuItem value="">All</MenuItem>
                {filterOptions.emails.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Role</InputLabel>
              <Select
                name="role"
                value={filters.role}
                onChange={handleFilterChange}
                label="Role"
              >
                <MenuItem value="">All</MenuItem>
                {filterOptions.roles.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Organisation</InputLabel>
              <Select
                name="organisation"
                value={filters.organisation}
                onChange={handleFilterChange}
                label="Organisation"
              >
                <MenuItem value="">All</MenuItem>
                {filterOptions.organisations.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Button variant="contained" color="primary" onClick={handleDownloadExcel}>
            Download Excel
          </Button>
        </Box>

        <Box sx={{ height: 600, width: "100%" }}>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <DataGrid
              rows={filteredRows}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[5, 10, 20]}
              pagination
            />
          )}
        </Box>
      </Container>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
}

export default RegisterInvestor;
